"use strict";
exports.__esModule = true;
exports.event = void 0;
var t = require("io-ts");
var basic_1 = require("./util/basic");
var createReqRes_1 = require("../request-handler/createReqRes");
var purchaseEvent = t.type({
    type: t.literal('purchase'),
    amount: t.number,
    currency: t.string
});
// These are events like new-user-purchase, where we want to still register them with partners like
// singular as a purchase event
var customPurchaseEvent = t.type({
    type: t.literal('customPurchase'),
    eventName: t.string,
    amount: t.number,
    currency: t.string,
    params: t.record(t.string, basic_1.primitiveValue)
});
var generalEvent = t.type({
    type: t.literal('general'),
    eventName: t.string,
    params: t.record(t.string, basic_1.primitiveValue)
});
exports.event = (0, createReqRes_1.createReqRes)('event', t.union([purchaseEvent, generalEvent, customPurchaseEvent]), basic_1.genericStatusMessage);
//# sourceMappingURL=event.js.map